import React, { useContext } from "react";
import { OnlineReservationContext } from "../index";
import InfoModal from "../../../components/Modal/Info";
import { Trans, useTranslation } from "react-i18next";

const LocalTaxInfoDialog = ({ handleClose }) => {
  const { business } = useContext(OnlineReservationContext);
  const { t } = useTranslation("reservations");

  return (
    <InfoModal
      show={true}
      title={t("localTaxInfoDialog.title")}
      handleClose={handleClose}
    >
      <p>
        <Trans i18nKey={"reservations:localTaxInfoDialog.description1"} />
        <br />
        <Trans i18nKey={"reservations:localTaxInfoDialog.description2"} />
        <br />
        <Trans i18nKey={"reservations:localTaxInfoDialog.description3"} />
        <br />
        <Trans i18nKey={"reservations:localTaxInfoDialog.description4"} />
      </p>
    </InfoModal>
  );
};

export default LocalTaxInfoDialog;
